import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Flex, Modal} from 'antd';

import ImgCalendar from '@/shared/pictures/calendar.png';
import ImgSecret from '@/shared/pictures/secret.png';
import ImgBack from '@/shared/pictures/back.svg';
import ImgClose from '@/shared/pictures/close.svg';

export const TrackerPage = observer(() => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCancel = () => {
    setIsModalOpen(false);

  };
  return (
    <div className='tracker-page'>
      <div className="container">
      <Flex align='center' gap={10}>
      <img src={ImgBack} alt="back" onClick={()=>navigate(-1)}/>
        <h1 className='tracker-page_title'>Спортивный трекер</h1>
      </Flex>
        <img className='tracker-page_calendar' src={ImgCalendar} alt="" />

      </div>

      <Modal
          title=''
          open={isModalOpen}
          footer={null}
          closeIcon={<img src={ImgClose} onClick={()=>navigate('/menu')}/>}
        >
          <div className='modal secret'>
            <img src={ImgSecret} className='modal_image' alt="img" />
            <p className='modal_text'>Проявляй активность! <br/>Мы сообщим тебе когда будет окрыт доступ к этому меню</p>
          </div>
      </Modal>


    </div>

  );
});